"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_RESIZE_MODE = 'contain';



//////////////////
// WEBPACK FOOTER
// ./node_modules/reactxp/dist/common/Image.js
// module id = 524
// module chunks = 0